import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

import getEnvironDomain from "./utils/getEnvironDomain";
import release from "./release";
import logger from "./logger";

// init
import "./utils/locale";

const currentDomain = getEnvironDomain();

release("header");

const RenderHeader = (
  elementId = {},
  firmsUrl,
  chatUrl,
  profileUrl,
  notificationsUrl,
  baseUrl,
  onUserSwitchedContact,
  getWsTokenUrl,
  webSocketUrl,
  onUserLogin
) => {
  // eslint-disable-next-line
  __webpack_public_path__ = `https://files.${currentDomain}/static/header/`;

  try {
    const defaultOptions = {
      elementId: "header",
      firmsUrl: "/webapi/firms",
      chatUrl: "/webapi/chat",
      profileUrl: "/webapi/profile",
      notificationsUrl: "/webapi/notifications",
      baseUrl: currentDomain,
      onUserSwitchedContact: null,
      getWsTokenUrl: `//wss.${currentDomain}/bcaster/websocket/token`,
      webSocketUrl: `wss://wss.${currentDomain}/bcaster/websocket/connect`,
      onUserLogin: null,
    };

    const opts =
      typeof elementId === "object" && elementId !== null
        ? elementId
        : {
            elementId,
            firmsUrl,
            chatUrl,
            profileUrl,
            notificationsUrl,
            baseUrl: baseUrl || currentDomain,
            onUserSwitchedContact,
            getWsTokenUrl,
            webSocketUrl,
            onUserLogin,
          };

    const options = { ...defaultOptions, ...opts };

    // eslint-disable-next-line
    const RenderedHeader = ReactDOM.render(
      <App
        apiUrl={options.firmsUrl}
        chatUrl={options.chatUrl}
        profileUrl={options.profileUrl}
        notificationsUrl={options.notificationsUrl}
        baseUrl={options.baseUrl}
        getWsTokenUrl={options.getWsTokenUrl}
        webSocketUrl={options.webSocketUrl}
        onUserLogin={options.onUserLogin}
      />,
      document.getElementById(options.elementId)
    );
    window.openFirmsSearchInHeader = () => {
      if (RenderedHeader && RenderedHeader.showSearch) {
        RenderedHeader.showSearch();
      }
    };
  } catch (err) {
    console.error("failed to render header", err); // Мы не хотим ломать старые браузеры от того, что в шапке что-то не транспилировано. Это грустно конечно, но должно быть переживаемо.
    logger.error(err, {
      sentryTitle: "Header: failed to render header",
    });
  }
};

// eslint-disable-next-line
const options =
  window &&
  window.__ATI__ &&
  window.__ATI__.header &&
  window.__ATI__.header.options;

RenderHeader(options);
